import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './apiSlice';
import { breadcrumbReducer } from './features/breadcrumb/breadcrumbSlice';
import { googleMapAuthReducer } from './features/google-map-auth/googleMapAuthSlice';
import { qualificationUIReducer } from './features/qualification/qualificationSlice';
import { snackbarReducer } from './features/snackbar/snackbarSlice';

export const store = configureStore({
  reducer: {
    snackbar: snackbarReducer,
    qualification: qualificationUIReducer,
    googleMapAuth: googleMapAuthReducer,
    breadcrumb: breadcrumbReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware().concat(apiSlice.middleware);
  },
  devTools: process.env.NODE_ENV !== 'production',
});
